package com.anjuros.website.templates.template10.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template10.components.template10BodyFont
import com.anjuros.website.templates.template10.components.template10HeadingFont
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.styles.Template10ContainerStyle
import com.anjuros.website.templates.template10.styles.Template10FooterLinkStyle
import com.anjuros.website.templates.template10.util.Template10CompanyDetails
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template10FooterSection() {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Template10Theme.InkFooter.rgb)
            .padding(top = 56.px, bottom = 20.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = Template10ContainerStyle.toModifier()
                .flexWrap(FlexWrap.Wrap)
                .gap(32.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top
        ) {
            Column(modifier = Modifier.gap(6.px)) {
                Span(
                    attrs = Modifier
                        .template10HeadingFont()
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template10Theme.Paper.rgb)
                        .toAttrs()
                ) {
                    AnjurosText(Template10CompanyDetails.CLIENTS_NAME_INFO)
                }
                Template10FooterLine(Template10CompanyDetails.CLIENTS_COMPANY_NUMBER_INFO)
                Template10FooterLine(Template10CompanyDetails.CLIENTS_COMPANY_ADDRESS_INFO)
            }

            Row(
                modifier = Modifier
                    .flexWrap(FlexWrap.Wrap)
                    .gap(24.px)
            ) {
                Template10Section.entries.forEach { section ->
                    Link(
                        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
                        path = section.path
                    ) {
                        Span(
                            attrs = Template10FooterLinkStyle.toModifier()
                                .template10BodyFont()
                                .fontSize(14.px)
                                .toAttrs()
                        ) {
                            Text(LocalText(section.title))
                        }
                    }
                }
            }

            Column(modifier = Modifier.gap(6.px)) {
                Template10FooterLine(Template10CompanyDetails.CLIENTS_PHONE_INFO)
                Template10FooterLine(Template10CompanyDetails.CLIENTS_EMAIL_INFO)
            }
        }

        Box(
            modifier = Template10ContainerStyle.toModifier()
                .height(1.px)
                .margin(top = 36.px)
                .backgroundColor(rgba(244, 241, 234, 0.12))
        )
        AnjurosCopyright(Modifier.margin(top = 14.px))
    }
}

@Composable
private fun Template10FooterLine(detail: Template10CompanyDetails) {
    Span(
        attrs = Modifier
            .template10BodyFont()
            .fontSize(14.px)
            .color(Template10Theme.StoneLight.rgb)
            .toAttrs()
    ) {
        AnjurosText(detail)
    }
}
